var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "#656565"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Address Manager-Overview-updating",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 2082,
    transform: "translate(-272 -448)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 314,
    height: 1712,
    transform: "translate(-32 -78)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23",
    d: "M-28 -77.5H278C279.933 -77.5 281.5 -75.933 281.5 -74V1633.5H-31.5V-74C-31.5 -75.933 -29.933 -77.5 -28 -77.5Z",
    stroke: "#4F5F72",
    strokeOpacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 283"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 46",
    x: -11.5,
    y: -15.5,
    width: 273,
    height: 117,
    rx: 3.5,
    fill: "#2F80ED",
    fillOpacity: 0.08,
    stroke: "#2F80ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.5C8 10.2239 8.22385 10 8.5 10C8.77615 10 9 10.2239 9 10.5V11V12H8V11V10.5ZM2.5 10.5C2.5 10.2239 2.72386 10 3 10H4C4.27614 10 4.5 10.2239 4.5 10.5V11V12H2.5V11V10.5ZM7 2H10.5C10.7761 2 11 2.22386 11 2.5V11.5C11 11.7761 10.7761 12 10.5 12H0.5C0.223857 12 0 11.7761 0 11.5V0.5C0 0.223857 0.223857 0 0.5 0H6.5C6.77615 0 7 0.223857 7 0.5V2ZM2.5 2C2.77614 2 3 2.22386 3 2.5C3 2.77614 2.77614 3 2.5 3C2.22386 3 2 2.77614 2 2.5C2 2.22386 2.22386 2 2.5 2ZM2.5 4C2.77614 4 3 4.22386 3 4.5C3 4.77614 2.77614 5 2.5 5C2.22386 5 2 4.77614 2 4.5C2 4.22386 2.22386 4 2.5 4ZM8.5 4C8.77615 4 9 4.22386 9 4.5C9 4.77614 8.77615 5 8.5 5C8.22385 5 8 4.77614 8 4.5C8 4.22386 8.22385 4 8.5 4ZM2.5 6C2.77614 6 3 6.22385 3 6.5C3 6.77615 2.77614 7 2.5 7C2.22386 7 2 6.77615 2 6.5C2 6.22385 2.22386 6 2.5 6ZM8.5 6C8.77615 6 9 6.22385 9 6.5C9 6.77615 8.77615 7 8.5 7C8.22385 7 8 6.77615 8 6.5C8 6.22385 8.22385 6 8.5 6ZM2.5 8C2.77614 8 3 8.22385 3 8.5C3 8.77615 2.77614 9 2.5 9C2.22386 9 2 8.77615 2 8.5C2 8.22385 2.22386 8 2.5 8ZM8.5 8C8.77615 8 9 8.22385 9 8.5C9 8.77615 8.77615 9 8.5 9C8.22385 9 8 8.77615 8 8.5C8 8.22385 8.22385 8 8.5 8ZM4.5 2C4.77614 2 5 2.22386 5 2.5C5 2.77614 4.77614 3 4.5 3C4.22386 3 4 2.77614 4 2.5C4 2.22386 4.22386 2 4.5 2ZM4.5 4C4.77614 4 5 4.22386 5 4.5C5 4.77614 4.77614 5 4.5 5C4.22386 5 4 4.77614 4 4.5C4 4.22386 4.22386 4 4.5 4ZM4.5 6C4.77614 6 5 6.22385 5 6.5C5 6.77615 4.77614 7 4.5 7C4.22386 7 4 6.77615 4 6.5C4 6.22385 4.22386 6 4.5 6ZM4.5 8C4.77614 8 5 8.22385 5 8.5C5 8.77615 4.77614 9 4.5 9C4.22386 9 4 8.77615 4 8.5C4 8.22385 4.22386 8 4.5 8Z",
    fill: "#4F5F72",
    fillOpacity: 0.72
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 2082,
    fill: "white",
    transform: "translate(-272 -448)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.e39326ce.svg";
export { ForwardRef as ReactComponent };